module.exports = __webpack_public_path__ + "static/media/Dashboard.b674bea6.svg";